import React from 'react';
import * as Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import {
    getChartsTooltipDateLabelFormatsWithoutTimeStamp,
    getChartsAxisDateTimeLabelFormats,
} from '../../data/translations/i18n';
import { ChartColors } from '../ReusableTrendsGraph/colors';
export const LineGraph: React.FC<{
    startDate: string;
    endDate: string;
    maxValueData?: any[];
    minValueData?: any[];   
    channelNumberIndex?: any;
    tickInterval: number;
    highChartGraphParameter: any[];
}> = (props) => {
    const chartRef = React.useRef<{
        chart: Highcharts.Chart;
        container: React.RefObject<HTMLDivElement>;
    }>(null);

    let highchartsConfigs,
        yaxisTitle,
        chartSeries0Name,
        chartSeries0NameColor,
        chartSeries1Name,
        chartSeriesShowInLegend,
        chartSeries1NameColor;
   
    props.highChartGraphParameter.map((temp: any) => {
        highchartsConfigs = temp.highchartsConfig;
        yaxisTitle = temp.yaxisTitle;
        chartSeries0Name = temp.chartSeries0Name;
        chartSeries0NameColor = temp.chartSeries0NameColor;
        chartSeries1Name = temp.chartSeries1Name;
        chartSeries1NameColor = temp.chartSeries1NameColor;
        chartSeriesShowInLegend = temp.chartSeriesShowInLegend;
    });

    highchartsConfigs = {
        credits: {
            enabled: false,
        },
        type: 'line',
        plotOptions: {
            series: {
                lineWidth: 2,
                turboThreshold: 0,
                marker: {
                    enabled: false,
                },
            },
        },
        exporting: {
            enabled: false,
        },
       yAxis: [
            {
                lineWidth: 1,
                title: {
                    text: '',
                },
            },
            {
                lineWidth: 1,
                opposite: true,
                title: {
                    text: yaxisTitle,
                    align: 'high',
                    offset: 3,
                    y: 70,
                    rotation: 360                                 
                },
                labels: { format: '{value} %' },
            },
        ],

        xAxis: {
            tickInterval: props.tickInterval,
            type: 'datetime',
            min: Date.parse(props.startDate),
            max: Date.parse(props.endDate),
            dateTimeLabelFormats: getChartsAxisDateTimeLabelFormats(),
            gridLineWidth: 1,
        },
        series: [
            {
                name: chartSeries0Name,
                data: props.maxValueData,
                color:props.channelNumberIndex ? ChartColors[props.channelNumberIndex === 1 ? 0 : props.channelNumberIndex % ChartColors.length] : chartSeries0NameColor
                            
            },
            {
                name: chartSeries1Name,
                data: props.minValueData,
                color: chartSeries1NameColor,            
                showInLegend: chartSeriesShowInLegend
            },
        ],
        tooltip: {
            dateTimeLabelFormats: getChartsTooltipDateLabelFormatsWithoutTimeStamp(),
            style: {
                fontFamily: 'Open Sans',
            },
            crosshairs: true,
            shared: false,
        },
        subtitle: {
            text: '',
        },
        legend: {
            layout: 'horizontal',
            align: 'left',
            verticalAlign: 'bottom',
        },
        title: {
            text: '',
            align: 'left',
        },
    };

    return (
        <>
            <HighchartsReact ref={chartRef} highcharts={Highcharts} options={highchartsConfigs} />
        </>
    );
};
